export function getElementRef (ref) {
  let el = ref
  if (Array.isArray(el)) {
    el = el[0]
  }

  return el
}
